<template>
  <div
    class="translation"
    :class="{
      'translation--translated': !!translation,
      'translation--editing': !!editingTranslation,
    }"
  >
    <div class="d-flex flex-row justify-space-between align-center">
      <span class="language-name">{{ language.name }}</span>
      <span v-if="!translation" class="pl-1 font-weight-light"
        >- sin traducción</span
      >
      <v-spacer />
      <template v-if="hasPermissions">
        <v-btn color="green" icon v-if="!translation" @click="$emit('toggle')">
          <v-icon>add</v-icon>
        </v-btn>
        <template v-else>
          <v-btn small color="red" icon @click="$emit('toggle')">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            small
            color="info"
            icon
            @click="edit"
            v-if="!editingTranslation"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </template>
    </div>
    <template v-if="translation">
      <div class="data" v-if="!editingTranslation">
        <span class="name">{{ translation.name }}</span>
        <p class="description">{{ translation.description }}</p>
      </div>
      <div v-else>
        <span>Nombre</span>
        <v-text-field
          v-model="editingTranslation.name"
          solo
          flat
          dense
          @change="onChanged"
          hide-details
          background-color="white"
          :rules="$rule('required|min3|max128')"
          :label="`Ingrese el nombre en ${language.name}`"
        />
        <div class="mt-3">Descripción</div>
        <v-textarea
          v-model="editingTranslation.description"
          solo
          flat
          class="mt-0 mb-2"
          rows="2"
          dense
          background-color="white"
          @change="onChanged"
          hide-details
          :label="`Ingrese la descripción en ${language.name}`"
          placeholder="Deje vacío para usar la descripción en el idioma original"
        />
        <div class="text-right mt-4 mb-2">
          <v-btn @click="cancel" depressed color="white">Cancelar</v-btn>
          <v-btn class="ml-2" @click="save" color="info">Aceptar</v-btn>
        </div>
      </div>
    </template>
  </div>
</template>
<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { ILanguage } from '../../interfaces/ILanguage';
  import { ITranslationData } from '../../api/services/translations.service';
  import { vueData } from '../../VueData';
  import { PermissionType } from '../../enums/PermissionType';

  @Component
  export default class CategoryTranslation extends Vue {
    @Prop() language: ILanguage;
    @Prop() translation: ITranslationData;
    editingTranslation: ITranslationData = null;

    @Watch('translation')
    translationChanged(newT, oldT) {
      if (newT && !oldT) this.edit();
      else if (!newT && oldT) this.editingTranslation = null;
    }

    edit() {
      this.editingTranslation = { ...this.translation };
    }

    save() {
      if (
        !this.editingTranslation.name &&
        !this.editingTranslation.description
      ) {
        this.$emit('toggle');
      } else {
        this.translation.name = this.editingTranslation.name;
        this.translation.description = this.editingTranslation.description;
        this.translation.id = undefined;
        this.translation.outdated = false;
        this.editingTranslation = null;
      }
    }

    onChanged() {
      this.$emit('change');
    }

    get hasPermissions() {
      return vueData.hasPermission(PermissionType.TranslationsManage);
    }

    cancel() {
      if (!this.editingTranslation.name && !this.editingTranslation.description)
        this.$emit('toggle');
      else this.editingTranslation = null;
    }
  }
</script>
